export const environment = {
  production: true,
  version: '1.74.2', // DO NOT MODIFY this is set by build server
  documentationURL: 'https://docs.jovaco.ca/pop/', //needs a final /
  apiUrl: 'api'
};
